export default {
  PRIORITY_1: {
    Title: 'Priority 1',
  },
  PRIORITY_2: {
    Title: 'Priority 2',
  },
  PRIORITY_3: {
    Title: 'Priority 3',
  },
  PRIORITY_4: {
    Title: 'Priority 4',
  },
  NONE: {
    Title: 'None',
  },
};
